import React, {useState, useRef, useCallback, useEffect, createContext} from 'react';
import {postApi} from './functions';

export const UserContext = createContext();

function useStateCallback(initialState) {
  const [state, setState] = useState(initialState);
  const cbRef = useRef(null); // init mutable ref container for callbacks

  const setStateCallback = useCallback((state, cb) => {
    cbRef.current = cb; // store current, passed callback in ref
    setState(state);
  }, []); // keep object reference stable, exactly like `useState`

  useEffect(() => {
    // cb.current is `null` on initial render, 
    // so we only invoke callback on state *updates*
    if (cbRef.current) {
      cbRef.current(state);
      cbRef.current = null; // reset callback after execution
    }
  }, [state]);

  return [state, setStateCallback];
}

export const UserProvider = (props) => {
	const [user, setUser] = useState({});
	const [worker, setWorkers] = useStateCallback({});
	const [themes, setThemes] = useState('/themes/default-dark.css');
	const [colours, setColours] = useState('/themes/default');

	const setWorker = async (_worker) => {
		if( !_worker ) return;
		return new Promise(async(resolve, reject) => {
			_worker = parseInt(_worker);
			if( !worker[_worker] ) {
				let params = new URLSearchParams();
				params.append('service', _worker);
				params.append('code', '1');
				const x = await postApi('/v3/portal/service', params);
				let workers = {...worker};
				workers[_worker] = x.data;
				setWorkers(workers, ()=>resolve(workers));
				return;
			}
			resolve(true);
		});
	};

	const setTheme = (_themes) => {
		if( _themes !== themes ) {
			setThemes(_themes);
			var link = document.createElement('link');
			link.href = _themes;
			link.id = '_themes';
			link.rel = 'stylesheet';
			link.type = 'text/css';
			var element = document.getElementById('_themes');
			if( element ) element.parentNode.replaceChild(link,element);
		}
	};
	
	const setColour = (_colour) => {
		if( _colour !== colours ) {
			setColours(_colour);
			var link = document.createElement('link');
			link.href = _colour;
			link.id = '_colour'
			link.rel = 'stylesheet';
			link.type = 'text/css';
			var element = document.getElementById('_colour');
			if( element ) element.parentNode.replaceChild(link,element);
		}
	}

	return (
		<UserContext.Provider value={{user, worker, themes, colours, setUser, setWorker, setTheme, setColour}}>
			{/*<link rel="stylesheet" id="_themes" type="text/css" href={`${themes}`} />*/}
			{props.children}
		</UserContext.Provider>
	);
}

export const TestService = (props) => {
	let test = /cloud1/.test(props.worker);
	return (
		<>
			{(parseInt(props.service) !== 1000 && test === true) &&
				<div className="card-footer p-0 text-center">
					<div className="alert alert-solid-success">
						Service running in Test Mode, any changes may not effect the live system!
					</div>
				</div>
			}
		</>
	);
}